import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-yellow-900 dark:bg-[#1C1B17] text-white dark:text-[#FFD54F] py-12 transition-colors duration-300 border-t border-transparent dark:border-[#594400]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          
          {/* COLUMNA 1 */}
          <div>
            <h3 className="text-xl font-black uppercase tracking-wider mb-4">Productos Apícolas Artesanales</h3>
            <p className="text-sm text-yellow-100 dark:text-[#FFE082]/80 leading-relaxed">
              Productos apícolas naturales de la más alta calidad, directamente desde el corazón de las colmenas.
            </p>
          </div>

          {/* COLUMNA 2 */}
          <div>
            <h4 className="text-base font-bold mb-6 text-yellow-200 dark:text-[#FFD54F]">Enlaces Rápidos</h4>
            <ul className="space-y-3 text-sm">
              <li><a href="/#home" className="hover:text-yellow-200 dark:hover:text-white transition duration-300">Inicio</a></li>
              <li><a href="/#products" className="hover:text-yellow-200 dark:hover:text-white transition duration-300">Productos</a></li>
              <li><a href="/#gallery" className="hover:text-yellow-200 dark:hover:text-white transition duration-300">Galería</a></li>
              <li><a href="/#about" className="hover:text-yellow-200 dark:hover:text-white transition duration-300">Nosotros</a></li>
              <li><a href="/#contact" className="hover:text-yellow-200 dark:hover:text-white transition duration-300">Contacto</a></li>
            </ul>
          </div>

          {/* COLUMNA 3: REDES SOCIALES */}
          <div>
            <h4 className="text-base font-bold mb-6 text-yellow-200 dark:text-[#FFD54F]">Síguenos</h4>
            <div className="grid grid-cols-3 gap-4 w-fit">
              {/* Facebook */}
              <a href="https://www.facebook.com/ProductosApicolasArtesanales/" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform text-yellow-100 dark:text-[#FFD54F]">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path></svg>
              </a>
              {/* Instagram */}
              <a href="https://www.instagram.com/productosapicolas.art/" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform text-yellow-100 dark:text-[#FFD54F]">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
              </a>
              {/* TikTok */}
              <a href="https://www.tiktok.com/@productosapicolas.art" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform text-yellow-100 dark:text-[#FFD54F]">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 448 512"><path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"/></svg>
              </a>
              {/* YouTube */}
              <a href="https://www.youtube.com/@productosapicolasartesanales" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform text-yellow-100 dark:text-[#FFD54F]">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"></path></svg>
              </a>
              {/* WhatsApp */}
              <a href="https://api.whatsapp.com/send?phone=3343902273&text=Hola,%20me%20interesan%20tus%20productos%20!" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform text-yellow-100 dark:text-[#FFD54F]">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zM223.9 413.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 334.3l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.4-186.6 184.4zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path></svg>
              </a>
            </div>
          </div>

          {/* COLUMNA 4 */}
          <div>
            <h4 className="text-base font-bold mb-6 text-yellow-200 dark:text-[#FFD54F]">Contacto</h4>
            <div className="text-xs text-yellow-100 dark:text-[#FFE082]/70 space-y-2">
              <p>C. José María Mercado 131</p>
              <p>Cruz Verde, 45754</p>
              <p>Zacoalco de Torres, Jal.</p>
              <p className="font-bold pt-2">+52 33 4390 2273</p>
              <p className="break-all">productosapicolasartesanales@gmail.com</p>
            </div>
          </div>
        </div>

        {/* COPYRIGHT Y CRÉDITOS */}
        <div className="border-t border-yellow-700 dark:border-[#594400] mt-12 pt-8 text-center flex flex-col items-center">
          <p className="text-xs text-yellow-200 dark:text-[#FFD54F]/50 uppercase tracking-widest font-bold">
            &copy; {new Date().getFullYear()} Productos Apícolas Artesanales de Zacoalco de Torres, Jalisco. Todos los derechos reservados.
          </p>
          <p className="text-xs text-yellow-100/70 dark:text-[#FFE082]/40 mt-4 tracking-wider">
            Sitio Web Desarrollado por TICs Educativas
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;